import React,{ useState,useRef,Fragment} from "react";
import {Edit } from "@material-ui/icons";
import { Button,Paper,Dialog,DialogActions,DialogContent,DialogTitle } from "@material-ui/core";
import Draggable from 'react-draggable';
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { paperPropsPass, useStyles } from '../css/muiStyle';
import  {AlertCompo} from '../js/components';


//Add a new role
function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  )
}

export default function ChangePass(props) {
    const classes=useStyles();
    const Gfunc=require('../Gfunc')
    const [open, setOpen] =useState(false);
    const [openA, setOpenA] =useState(false);
    const [messageA, setMessageA] =useState('');
    const [severity, setSeverity] =useState("info");
    const [prvPass, setPrvPass] =useState("");
    const [newPass, setNewPass] =useState("");
    const [confPass, setConfPass] =useState("");
    const label1="Ancien mot de passe"
    const label2="Nouveau mot de passe"
    const label3="Confirmer le nouveau mot de passe"
 
    
    const handleClickOpen = () => { 
        setOpen(true); 
        setPrvPass('');
        setNewPass('');
        setConfPass('');
      };
      const handleClose = () => { setOpen(false); };

     //handle alerts properties
     const handleAlert=(open,severity,message)=>{
      setOpenA(open)
      setSeverity(severity)
      setMessageA(message)
      setTimeout(function(){
        setOpenA(false)
      }, 5000);
    }
    const handleSubmit= async(e) =>{
      if (newPass===confPass){
        const response = await Gfunc.axiosPostAction('pass.php','',{opass:prvPass,npass:newPass});
        if(response.data.err&&response.data.err!=="-1"){
          handleAlert(true,'error',response.data.err)
        }else
        Gfunc.axiosResponse(response,()=>{
          handleAlert(true,'success',"Votre mot de passe a été modifié avec succès.")
          setOpen(false)
        })
      }
      else {
        handleAlert(true,'warn',"Veuillez ressaisir votre mot de passe correctement !")
        setConfPass('')
      }
    
  }
    
  return (
    <Fragment>
      <span id="userName" onClick={()=>handleClickOpen()}>{props.getInfo().name}</span>
      <Dialog
            open={open}
            id='changePass'
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            PaperProps={paperPropsPass}
       >
        <DialogTitle className={classes.topDivTitle} id="draggable-dialog-title" >Modifier le mot de passe</DialogTitle>
        <ValidatorForm ref={useRef(null)} onSubmit={handleSubmit} onError={errors => console.log(errors)} >
            <DialogContent>
            <AlertCompo severity={severity} open={openA} setOpen={setOpenA} message={messageA} />
            <TextValidator variant="outlined" size="small"  label={label1} value={prvPass} className='smallText'
                                    onChange={e =>setPrvPass(e.target.value)} 
                                    validators={['required']} 
                                    errorMessages={["Veuillez saisir votre mot de passe !"]} 
                                    type="password"
                                    autoFocus fullWidth
                                    />
                                    <br/>
            <TextValidator variant="outlined" size="small"  label={label2} value={newPass}  className='smallText'
                                    onChange={e =>setNewPass(e.target.value)} 
                                    validators={['required']} 
                                    errorMessages={["Veuillez saisir un nouveau mot de passe !"]} 
                                    type="password" fullWidth
                                    />
                                     <br/>
            <TextValidator variant="outlined" size="small"  label={label3} value={confPass}  className='smallText' 
                                    onChange={e =>setConfPass(e.target.value)} 
                                    validators={['required']} 
                                    errorMessages={["Veuillez ressaisir le nouveau mot de passe !"]} 
                                    type="password" fullWidth
                                    />
            </DialogContent>
            <DialogActions>
              <Button variant="contained" type='submit' color="primary" startIcon={<Edit/>}>Modifier</Button>
              <Button variant="contained"  onClick={handleClose} color="secondary">FERMER</Button>
            </DialogActions>
        </ValidatorForm>
      </Dialog>
      </Fragment>
  );
}
